/*
 * ty-pdp-spin · הגשר בין בורר הווריאנט של דף המוצר לבין מנוע הסיבוב.
 * ראו snippets/ty-pdp-spin.liquid. נכתב 22.09.2026.
 *
 * 🔴 המנוע (ty-cs-hero-spin.js) מחליף גימור רק בלחיצה על עיגול משלו.
 *    בדף הרגיל הלקוח בוחר צבע בבורר של הטמפלט, ולכן הגשר מסמן את העיגול
 *    המוסתר המתאים ולוחץ עליו. אין כאן שום שינוי בקוד המנוע.
 * 🔴 שני מקורות, ושניהם נדרשים:
 *    ① אירוע change על הרדיו, מיד בלחיצה, לפני שהשרת ענה.
 *    ② variantChange של הערכה, אחרי שהשרת ענה. הוא האמת, והוא תופס גם
 *       בחירה אוטומטית (ty-condition-auto) שאינה יורה change.
 * 🔴 פונקציות הצבע של הגלים **נחלצות מ-ty-cs-hero.liquid החי בזמן הבנייה**,
 *    במקום הסמן שלמטה. מימוש מקביל היה נסחף בשקט מהגוונים שכבר אושרו.
 */
(function () {
  'use strict';

  /* נחלץ מ-sections/ty-cs-hero.liquid החי בזמן הבנייה. לא לערוך כאן. */
  function hexRgb(h) {
    var v = String(h || '').trim().replace('#', '');
    if (v.length === 3) v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
    if (!/^[0-9a-fA-F]{6}$/.test(v)) return null;
    return [parseInt(v.slice(0, 2), 16), parseInt(v.slice(2, 4), 16), parseInt(v.slice(4, 6), 16)];
  }

  function tyAlpha(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    var l = (mx + mn) / 2;
    var sat = d ? d / (1 - Math.abs(2 * l - 1)) : 0;
    var chroma = sat * 100 * (100 - Math.abs(2 * l * 100 - 100)) / 100;
    if (chroma >= 2) return 1;
    /* 🔴 עקומה רוויה ולא קו ישר. יובל ביקש שהכסוף יהיה «יותר לבן ופחות
       אפור», ובקו ישר הוא נשאר רחוק מהלבן. החזקה 0.34 מרימה את הכסוף
       מהר ומשטחת בקצה, ולכן כסוף ×2.28 ולבן ×2.41, קרובים זה לזה.
       📌 שחור מקבל 1.00 בדיוק, כי הביטוי מתאפס מתחת ל-0.2. */
    return Math.round((1 + 1.55 * Math.pow(Math.max(0, l - 0.2), 0.34)) * 100) / 100;
  }

  function boost(rgb, shift) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    var l = (mx + mn) / 2;
    var sat = d ? d / (1 - Math.abs(2 * l - 1)) : 0;
    var h = 0;
    if (d) {
      if (mx === r) h = ((g - b) / d) % 6;
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
      if (h < 0) h += 360;
    }
    h = (h + (shift || 0) + 360) % 360;
    // 🔴 סבב שני, 10.09.2026. יובל: «הבורדו חזק עובד טוב מאוד, אבל אז
    //    שאר הצבעים די דומים ולא רואים את ההבדל».
    //    הסיבה נמדדה: שלושה מארבעת הגימורים כמעט ניטרליים, והגוון שלהם
    //    נופל כולו בטווח 208 עד 240 מעלות. **בהירות קבועה ורוויה מקובעת
    //    מחקו את מה שכן הבדיל ביניהם.**
    //    ⟹ הבהירות **עוקבת אחרי הגימור** בטווח שמור, כך ששחור יוצא כהה
    //      וכסוף יוצא בהיר. והרוויה נמתחת בעקומה, כדי שכחול קרח יצא
    //      כחול של ממש בעוד כסוף נשאר חיוור.
    // ⚠️ הטווח התחתון נשמר מעל 0.34, אחרת הזוהר נבלע ברצועה ב-#121212.
    /* ty-cs-fx-official >>> */
    /* 🔴 הגוון בא מ-swatch_map, והוא הוחלף לגוונים הרשמיים של אפל
       (נדגמו מ-apple.com ב-21.09.2026). שלושה תיקונים כאן, וכל אחד נדרש:
       ① הגברה פי k אחיד. העקומה הקודמת הגבירה את החיוורים פי 7 ואת
         הבורדו פי 1.8, ולכן היא שהמציאה את הצבעים ולא הגימורים.
       ② אין רצפת רוויה לניטרלי. עם הרצפה, אפור טהור (R=G=B, גוון 0°)
         יצא **אדמדם**. נמדד: rgb(113,89,89) על השחור.
       ③ כרומה מתחת ל-2 ⟵ אפס רוויה. «לבן» #F7F6F5 נושא רוויה 0.11,
         וזה הפרש של 2 יחידות ב-RGB, כלומר רעש. הכרומה היא המדד.
       יובל 21.09.2026: «למה הוא עדיין חום?» */
    var tyChroma = sat * 100 * (100 - Math.abs(2 * l * 100 - 100)) / 100;
    var tyNeutral = tyChroma < 2;
    sat = tyNeutral ? 0 : Math.min(0.92, sat * 2.2);
    if (tyNeutral) h = 0;
    l = 0.26 + 0.52 * l;
    /* <<< ty-cs-fx-official */
    /* ty-cs-fx-neutral-lift >>> */
    /* 🔴 גימור ניטרלי מקבל את הבהירות של עצמו במקום להידחס לאמצע.
       הבלוק שמעל נותן `0.26 + 0.52*l`, ולכן שחור שבהירותו 0.14 יצא
       rgb(85) שהוא אפור בינוני, ולבן שבהירותו 0.96 יצא rgb(194).
       יובל 21.09.2026: «השחור צריך שייראה שחור והלבן לבן».
       📌 שלוש השכבות נבדלות **רק בבהירות**, כי הרוויה כאן אפס.
          בלי ההפרש הזה שלושתן יוצאות זהות, וזה כתם ולא גל. */
    if (tyNeutral) {
      var tyRaw = (mx + mn) / 2;
      l = 0.1 + 0.85 * tyRaw;
      /* 🔴 יובל 21.09.2026: «הכסוף לא נראה טוב, תעשה שיהיה יותר לבן ופחות
         אפור». הקו הישר לבדו נתן לכסוף 0.754, שהוא אפור בינוני.
         ⟹ הרמה נוספת על החצי העליון בלבד, בעקומת smoothstep שרוויה
           ב-0.8. **השחור אינו זז**, כי הרמה מתאפסת מתחת ל-0.5. */
      var tyT = Math.max(0, Math.min(1, (tyRaw - 0.5) / 0.3));
      l += 0.14 * tyT * tyT * (3 - 2 * tyT);
      /* 🔴 חסם לפני הפיצול לשכבות, ולא אחריו. בלעדיו הלבן יצא 1.057,
         ושתיים משלוש השכבות נחתכו ל-255 והפכו זהות. זה בדיוק הכתם
         השטוח שהתחלנו ממנו. ⟹ הבהירות נעצרת ב-0.9, והנוכחות מגיעה
         מהשקיפות. **נתפס במדידה של הפלט, לא בהנחה.** */
      l = Math.min(0.9, l);
      l += shift > 0 ? 0.078 : (shift < 0 ? -0.078 : 0);
      l = Math.max(0.04, Math.min(1, l));
    }
    /* <<< ty-cs-fx-neutral-lift */
    var c = (1 - Math.abs(2 * l - 1)) * sat;
    var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    var m = l - c / 2;
    var t = h < 60 ? [c, x, 0] : h < 120 ? [x, c, 0] : h < 180 ? [0, c, x]
      : h < 240 ? [0, x, c] : h < 300 ? [x, 0, c] : [c, 0, x];
    return t.map(function (v) { return Math.round((v + m) * 255); });
  }

  function setup(root) {
    if (!root || root.dataset.typsReady === '1') return;
    root.dataset.typsReady = '1';
    var cidx = Number(root.dataset.typsCidx);
    var dots = [].slice.call(root.querySelectorAll('[data-tych-dot]'));
    var names = dots.map(function (d) { return d.dataset.tychDot; });
    var fx = root.classList.contains('typs--fx');
    var current = null;
    var pressed = dots.filter(function (d) { return d.getAttribute('aria-pressed') === 'true'; })[0];
    if (pressed) current = pressed.dataset.tychDot;

    function dotOf(name) { return dots.filter(function (d) { return d.dataset.tychDot === name; })[0]; }

    function paintFx(name) {
      if (!fx || typeof boost !== 'function') return;
      var d = dotOf(name);
      if (!d) return;
      var rgb = hexRgb(window.getComputedStyle(d).getPropertyValue('--c'));
      if (!rgb) return;
      root.style.setProperty('--tych-fx-rgb', boost(rgb, 0).join(', '));
      root.style.setProperty('--tych-fx2-rgb', boost(rgb, 38).join(', '));
      root.style.setProperty('--tych-fx3-rgb', boost(rgb, -28).join(', '));
      var a = tyAlpha(rgb);
      root.style.setProperty('--tych-fx-a', a);
      root.classList.toggle('tych--lift', a > 1);
    }

    function apply(name) {
      if (!name || names.indexOf(name) < 0 || name === current) return;
      current = name;
      dots.forEach(function (d) {
        var on = d.dataset.tychDot === name;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-pressed', String(on));
      });
      paintFx(name);
      root.dataset.typsColor = name;
      /* לפני שהמנוע התחיל הוא קורא בעצמו את העיגול הלחוץ, ולכן הלחיצה בטוחה בשני המצבים. */
      var hit = dotOf(name);
      if (hit) hit.click();
    }

    /* ① הרדיו, מיד בלחיצה. הבורר מרונדר מחדש בכל החלפה, ולכן האזנה על document. */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !t.closest || !t.closest('variant-selects')) return;
      if (names.indexOf(t.value) >= 0) apply(t.value);
    });

    /* ② ההחלפה שהשרת אישר */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (v && v.options && cidx >= 0) apply(v.options[cidx]);
      });
    }

    paintFx(current);
    if (current) root.dataset.typsColor = current;
  }

  function all() {
    var list = document.querySelectorAll('.typs[data-tych-spin]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
